import { createFileRoute } from '@tanstack/react-router'

import { Authorisation } from "@/lib/auth/components/auth-provider";
import Unauthorized from "@/lib/auth/components/unauthorized";
import { ROLES } from "@/lib/auth/roles";
import PerformanceAdviserOverTime from "@/modules/performance/adviser-over-time";
import {ELEVATION_ADVISER_PERFORMANCE_OVER_TIME_PATH} from "@/utils/urls";

export const Route = createFileRoute(ELEVATION_ADVISER_PERFORMANCE_OVER_TIME_PATH)({
  component: RouteComponent,
})

function RouteComponent() {
  return (
    <div className={'flex flex-col items-center justify-center'}>
      <Authorisation roles={[ROLES.ROLE_ELEVATION]} permissions={[]}
        forbiddenFallback={<Unauthorized/>}>
        <PerformanceAdviserOverTime />
      </Authorisation>
    </div>
  )
}
